import { API_CONFIG, apiUtils } from '../config.js';

// Organization Management API
export const organizationApi = {
  // Create organization
  createOrganization: async (organizationData) => {
    const url = `${API_CONFIG.BASE_URL}/organization/create`;
    return apiUtils.makeAuthenticatedRequest(url, {
      method: 'POST',
      body: JSON.stringify(organizationData),
    });
  },

  // Update organization
  updateOrganization: async (organizationId, organizationData) => {
    const url = `${API_CONFIG.BASE_URL}/organization/update/${organizationId}`;
    return apiUtils.makeAuthenticatedRequest(url, {
      method: 'PUT',
      body: JSON.stringify(organizationData),
    });
  },

  // Update current organization profile
  updateOrganizationProfile: async (orgData) => {
    const url = `${API_CONFIG.BASE_URL}/organization/profile`;
    return apiUtils.makeAuthenticatedRequest(url, {
      method: 'PUT',
      body: JSON.stringify(orgData),
    });
  },

  // Get organization details
  getOrganizationDetails: async () => {
    const url = `${API_CONFIG.BASE_URL}/organization/details`;
    return apiUtils.makeAuthenticatedRequest(url);
  },

  // Get organization by ID
  getOrganizationById: async (organizationId) => {
    const url = `${API_CONFIG.BASE_URL}/organization/get-by-id/${organizationId}`;
    return apiUtils.makeAuthenticatedRequest(url);
  },

  // Delete organization
  deleteOrganization: async (organizationId) => {
    try {
      const token = localStorage.getItem('authToken');
      const headers = {
        ...(token && { 'Authorization': `Bearer ${token}` })
      };

      const response = await fetch(`${API_CONFIG.BASE_URL}/organization/delete/${organizationId}`, {
        method: 'DELETE',
        headers
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      const text = await response.text();
      return text ? JSON.parse(text) : { success: true };
    } catch (error) {
      apiUtils.handleError(error);
      throw error;
    }
  },

  // Get organization statistics
  getOrganizationStatistics: async () => {
    const url = `${API_CONFIG.BASE_URL}/organization/statistics`;
    return apiUtils.makeAuthenticatedRequest(url);
  },

  // Helper to get academic years (Centralized logic)
  getAcademicYears: () => {
      const currentYear = new Date().getFullYear();
      const currentMonth = new Date().getMonth(); // 0-11
      
      // If we are in Jan-Mar, the current academic year started last year (e.g., in March 2025, year is 2024-2025)
      // If we are in Apr-Dec, the current academic year started this year (e.g., in April 2025, year is 2025-2026)
      // Adjust this logic based on your school's session start (assuming April start)
      const startYear = currentMonth < 3 ? currentYear - 1 : currentYear;
      
      const years = [
          `${startYear - 1}-${startYear}`,
          `${startYear}-${startYear + 1}`,
          `${startYear + 1}-${startYear + 2}`,
      ];
      
      return {
          current: `${startYear}-${startYear + 1}`,
          available: years
      };
  }
};

export default organizationApi;
